export default function useMediaHook() {
  const uploadMedia = (organizationUuid: string, files: any) => {
    console.log('uploadMedia -- TODO', { organizationUuid, files});
  }

  return {
    uploadMedia,
  }
}